import React, { HTMLAttributes, ReactNode } from 'react';
import { Wrapper } from './styles';

export interface Props extends HTMLAttributes<HTMLButtonElement> {
  /** Texto do botão */
  children: ReactNode;

  /** Tipo do botão */
  variant?: 'default' | 'outlined';

  /** Cor do background ou da borda (caso outlined) */
  backgroundColor?: string;

  /** Cor do texto */
  color?: string;

  /** Botão desabilitado */
  disabled?: boolean;
}

export const Button = ({
  children,
  variant = 'default',
  backgroundColor = '#2B45D4',
  color = '#fff',
  disabled = false,
  ...props
}: Props) => {
  return (
    <Wrapper
      {...props}
      disabled={disabled}
      variant={variant}
      backgroundColor={backgroundColor}
      color={color}
    >
      {children}
    </Wrapper>
  );
};
